import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  gap: 62px;
  padding-top: 140px;
`;

export const Main = styled.main`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  padding: ${theme.spacings.xxlarge} ${theme.spacings.xxxlarge};

  @media screen and (min-width: ${theme.grid.xltablet.breakpoint}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 60px;
  }

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    > .block {
      display: flex;

      &.column {
        flex-direction: column;
        gap: ${theme.spacings.medium};
      }

      p {
        font-size: ${theme.font.sizes.p2};
        line-height: ${theme.font.lineHeights.p2};
      }

      p.label {
        color: ${theme.colors.gray5};
        display: flex;
      }

      p.value {
        color: ${theme.colors.gray6};
        margin-left: ${theme.spacings.xxsmall};
      }
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  .alert, .error {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.2rem;
    color: ${theme.colors.supportAlert};
    margin-bottom: 0.5rem;

    svg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  .accordionContainer {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .accordionItem {
      position: relative;
      display: flex;
      width: 100%;

      p {
        flex-basis: 100%;
        color: ${theme.colors.gray6};
        font-size: 0.9rem;
        align-self: center;
        font-weight: 400;

        display: block;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        svg {
          width: 15px;
          height: 15px;
          color: ${theme.colors.primaryBlue};

          :hover {
            transform: scale(1.1);
          }
        }
      }

      ::before {
        position: absolute;
        display: inline-block;
        content: "";
        border-top: 1px solid ${theme.colors.gray2};
        width: 100%;
        left: 0;
        transform: translateY(-1rem);
      }

      &:first-child {
        margin-top: 0.5rem;
        background-color: ${theme.colors.grayBg};
      }

      &:first-child::before {
        content: none;
      }

      &.spaceBetween {
        justify-content: space-between;

        p {
          flex-basis: auto;
        }
      }
    }
  }
`;
